import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, Transition as _Transition, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/twitter-logo.svg'
import _imports_1 from '@/assets/images/metamask-logo.png'
import _imports_2 from '@/assets/images/walletconnect-logo.png'
import _imports_3 from '@/assets/images/coinbase-wallet-logo.png'
import _imports_4 from '@/assets/images/apple-pay-logo.svg'
import _imports_5 from '@/assets/images/visa-logo.svg'
import _imports_6 from '@/assets/images/mastercard-logo.svg'
import _imports_7 from '@/assets/images/amex-logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-06abe5ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "campaign-action" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "checkout-backdrop" }, null, -1))
const _hoisted_3 = { class: "checkout-container" }
const _hoisted_4 = { class: "checkout-header" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "checkout-close-button" }
const _hoisted_8 = {
  key: 0,
  class: "checkout-details"
}
const _hoisted_9 = {
  key: 1,
  class: "checkout-tweet"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "twitter logo"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tweet this drop", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 2,
  class: "checkout-subscribe"
}
const _hoisted_15 = { class: "checkout-subscribe-title" }
const _hoisted_16 = ["data-creator-address", "data-tweet-subtext"]
const _hoisted_17 = {
  key: 3,
  class: "checkout-post-mint-message"
}
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  key: 4,
  class: "checkout-platform-links"
}
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "View transaction details", -1))
const _hoisted_22 = { key: 1 }
const _hoisted_23 = {
  key: 0,
  class: "checkout-payment-method"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Pay with ETH", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "checkout-payment-method-logos" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "MetaMask"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "WalletConnect"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "Coinbase Wallet"
  })
], -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Pay with card", -1))
const _hoisted_28 = { class: "checkout-payment-method-logos" }
const _hoisted_29 = {
  key: 0,
  src: _imports_4,
  alt: "Apple Pay"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "Visa"
}, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "Mastercard"
}, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: "Amex"
}, null, -1))
const _hoisted_33 = {
  key: 1,
  class: "checkout-buy-with-eth"
}
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "checkout-buyer-info" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "checkout-buyer-title" }, "Buying as", -1))
const _hoisted_37 = ["data-network", "data-fallback-provider"]
const _hoisted_38 = {
  key: 1,
  class: "checkout-error-message"
}
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { key: 2 }
const _hoisted_42 = { key: 3 }
const _hoisted_43 = { key: 4 }
const _hoisted_44 = { class: "checkout-tx-hash-container" }
const _hoisted_45 = ["href"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "View transaction details", -1))
const _hoisted_47 = ["data-network", "data-address"]
const _hoisted_48 = ["disabled"]
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { key: 2 }
const _hoisted_52 = {
  key: 3,
  class: "spinner centered black"
}
const _hoisted_53 = { key: 4 }
const _hoisted_54 = { key: 5 }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Pay with card", -1))
const _hoisted_56 = { class: "checkout-payment-method-logos" }
const _hoisted_57 = {
  key: 0,
  src: _imports_4,
  alt: "Apple Pay"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "Visa"
}, null, -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "Mastercard"
}, null, -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: "Amex"
}, null, -1))
const _hoisted_61 = { key: 1 }
const _hoisted_62 = ["data-network", "data-fallback-provider"]
const _hoisted_63 = {
  key: 1,
  class: "checkout-actions"
}
const _hoisted_64 = {
  key: 0,
  class: "checkout-buy-with-card"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "checkout-input-label"
}, " Email ", -1))
const _hoisted_66 = {
  key: 0,
  class: "checkout-error-message"
}
const _hoisted_67 = {
  key: 0,
  class: "checkout-error-message"
}
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { key: 1 }
const _hoisted_70 = { class: "checkout-card-input" }
const _hoisted_71 = {
  key: 0,
  class: "checkout-processing"
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "Processing transaction"),
  /*#__PURE__*/_createElementVNode("p", null, "This might take a few seconds")
], -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "spinner centered" }, null, -1))
const _hoisted_74 = ["href"]
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "View transaction details", -1))
const _hoisted_76 = ["disabled"]
const _hoisted_77 = {
  key: 0,
  class: "spinner centered black"
}
const _hoisted_78 = { key: 1 }
const _hoisted_79 = { key: 2 }
const _hoisted_80 = { key: 3 }
const _hoisted_81 = { key: 4 }

import { BigNumber } from '@ethersproject/bignumber';
import { formatEther, parseUnits } from '@ethersproject/units';
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue';
import { ArrowTopRightOnSquareIcon, XMarkIcon } from '@heroicons/vue/24/solid';
import dayjs from 'dayjs/esm/index';
import calendar from 'dayjs/esm/plugin/calendar';
import relativeTime from 'dayjs/esm/plugin/relativeTime';
import JSConfetti from 'js-confetti';
import { capitalize, computed, onMounted, onUnmounted, ref } from 'vue';
import { CROSSMINT_EMAIL_LOCAL_STORAGE_KEY, ETHEREUM_NETWORK_NAMES } from '@/common/constants';
import CardPaymentForm from '@/components/CardPaymentForm.vue';
import CheckoutItems from '@/components/CheckoutItems.vue';
import CheckoutItemsForCard from '@/components/CheckoutItemsForCard.vue';
import DelegationPicker from '@/components/DelegationPicker.vue';
import NumberToMintInput from '@/components/NumberToMintInput.vue';
import OptimismBanner from '@/components/OptimismBanner.vue';
import PlatformLinks from '@/components/PlatformLinks.vue';
import RecipientAddressInput from '@/components/RecipientAddressInput.vue';
import { useMint } from '@/composables/mint';
import { CrossmintFiatCostBreakdown, getEtherscanBase, pluralize, transformError, tryGetLocalStorage } from '@/lib/claimUtil';
import * as telemetry from '@/lib/telemetry';
import { subscribedToCreator } from '@/lib/telemetry';
import { useClaimStore } from '@/store/claimStore';

interface BuyButtonProps {
  onSuccess?: () => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyButton',
  props: {
    onSuccess: { type: Function }
  },
  setup(__props: any) {

const props = __props as {
  onSuccess?: () => void;
};

_useCssVars(_ctx => ({
  "7a81ad31": (_unref(store).clientColors.themePrimary)
}))

dayjs.extend(calendar);
dayjs.extend(relativeTime);

const CalendarFormat = {
  sameDay: '[today] [at] h:mm A', // today at 2:30 PM
  nextDay: '[tomorrow] [at] h:mm A', // tomorrow at 2:30 PM
  nextWeek: 'MMM D YYYY [at] h:mm A', // Feb 5 2023, at 2:30 PM
  lastDay: '[yesterday] h:mm A', // yesterday at 2:30 PM
  lastWeek: '[last] dddd [at] h:mm A', // last Monday at 2:30 PM
  sameElse: 'MMM D YYYY [at] h:mm A' // Mar 1 2023 at 2:30 PM
};



const store = useClaimStore();

const isModalOpen = ref(false);
const showConnectWidget = ref(false);
const showSubscribeWidget = ref(false);
const checkoutState = ref<'payment-method' | 'buy-with-eth' | 'buy-with-card' | 'success'>('buy-with-eth');
const email = ref('');
const emailError = ref(false);
const recipientAddress = ref('');
const isProcessingCardPayment = ref(false);
const paymentMethod = ref<'eth' | 'card'>('eth');
const itemPriceWithCard = ref<BigNumber>(BigNumber.from(0));
const manifoldFeeWithCard = ref<BigNumber>(BigNumber.from(0));
const processingFeesWithCard = ref<BigNumber>(BigNumber.from(0));
const totalCostWithCard = ref<BigNumber>(BigNumber.from(0));
const loadingPrices = ref(true);
const doesCardPayerHaveAWallet = ref(false);

const goToBuyWithEth = () => {
  telemetry.paymentPreview('eth');
  checkoutState.value = 'buy-with-eth';
};

const goToBuyWithCard = () => {
  telemetry.paymentPreview('card');
  checkoutState.value = 'buy-with-card';
  doesCardPayerHaveAWallet.value = false;

  if (store.hasAllowlist) {
    // HACK: Need this since at this stage we don't have a wallet to check if they are on the allow list
    // which makes Crossmint's simulation of the tx fail and therefore we can't get the price
    onCardPaymentCostChanged({
      price: parseUnits(`${(store.totalCostInUsd).toFixed(2)}`, 2),
      gasFees: parseUnits(`${(store.manifoldFeeInUsd).toFixed(2)}`, 2),
      // HACK: We add 3% to the total cost to account for the ~3% fee that Crossmint charges
      totalPrice: parseUnits(`${(store.totalCostInUsd + store.totalCostInUsd * 0.03).toFixed(2)}`, 2)
    });
  }
};

const {
  mint,
  tx,
  isError: isMintingError,
  error: mintingError,
  isLoading: isMinting
} = useMint({
  onSuccess: () => {
    new JSConfetti().addConfetti({
      emojis: store.checkoutEmojis,
      confettiRadius: 90,
      confettiNumber: 200
    });

    // HACK: Need this since for some reason
    // our subscribe widget logic doesn't populate the widget when the modal opens
    setTimeout(() => {
      showSubscribeWidget.value = true;
    }, 0);

    isModalOpen.value = true;
    checkoutState.value = 'success';

    telemetry.paymentSuccess(
      'eth',
      store.tokensToMint,
      'same-wallet',
      // This is 'ETH' in the default case
      store.erc20Symbol.toLowerCase()
    );

    if (props.onSuccess) {
      props.onSuccess();
    }
  },
  onError: (error: any) => {
    telemetry.paymentError(
      'eth',
      store.tokensToMint,
      'same-wallet',
      transformError(error)?.error
    );
  }
});

const mintTokens = async () => {
  telemetry.paymentAttempt('eth', store.tokensToMint, 'same-wallet');

  if (!window.ManifoldEthereumProvider.chainIsCorrect()) {
    await window.ManifoldEthereumProvider.switchToCorrectChain();
    await _waitForChainIsCorrect();
  }

  mint({ amount: store.tokensToMint });
};

const _waitForChainIsCorrect = () => {
  const poll = (resolve: any) => {
    if (window.ManifoldEthereumProvider.chainIsCorrect()) resolve();
    else setTimeout((_) => poll(resolve), 50);
  };

  return new Promise(poll);
};

const numberToMintChanged = (numberToMint: number) => {
  store.tokensToMint = numberToMint;
  loadingPrices.value = true;
};

const onCardPaymentStarted = () => {
  telemetry.paymentAttempt('card', store.tokensToMint, recipientAddress.value ? 'different-wallet' : 'custodial-wallet');
  isModalOpen.value = true;
  isProcessingCardPayment.value = true;
  checkoutState.value = 'buy-with-card';
};

const onCardPaymentSuccess = (paymentMethodType: string) => {
  new JSConfetti().addConfetti({
    emojis: ['🎉'],
    confettiRadius: 90,
    confettiNumber: 200
  });

  // HACK: Need this since for some reason
  // our subscribe widget logic doesn't populate the widget when the modal opens
  setTimeout(() => {
    showSubscribeWidget.value = true;
  }, 0);

  paymentMethod.value = 'card';
  isModalOpen.value = true;
  isProcessingCardPayment.value = false;
  checkoutState.value = 'success';

  telemetry.paymentSuccess(
    'card',
    store.tokensToMint,
    recipientAddress.value ? 'different-wallet' : 'custodial-wallet',
    paymentMethodType
  );

  if (props.onSuccess) {
    props.onSuccess();
  }
};

const onCardPaymentError = () => {
  isProcessingCardPayment.value = false;
  checkoutState.value = 'buy-with-card';
  isModalOpen.value = true;
  telemetry.paymentError('card', store.tokensToMint, recipientAddress.value ? 'different-wallet' : 'custodial-wallet');
};

const onCardPaymentCostChanged = (costBreakdown: CrossmintFiatCostBreakdown) => {
  const totalManifoldFees = BigNumber.from(((store.manifoldFeeInUsd || store.tokensToMint) * 100).toFixed(0));
  manifoldFeeWithCard.value = totalManifoldFees;
  totalCostWithCard.value = costBreakdown.totalPrice;
  if (store.isFreeClaim) {
    itemPriceWithCard.value = BigNumber.from(0);
    processingFeesWithCard.value = costBreakdown.totalPrice.sub(totalManifoldFees);
  } else {
    itemPriceWithCard.value = costBreakdown.price.sub(totalManifoldFees);
    processingFeesWithCard.value = costBreakdown.totalPrice.sub(totalManifoldFees).sub(itemPriceWithCard.value);
  }
  loadingPrices.value = false;
};

const onCardPaymentRecipientWalletChanged = async (wallet: string) => {
  store.mintForWallet = wallet;
  doesCardPayerHaveAWallet.value = true;

  await store.resetMerkleData();
};

const validateEmail = (event: any) => {
  const email = event.target.value;

  const re = /\S+@\S+\.\S+/;
  if (re.test(email)) {
    emailError.value = false;
    return;
  }

  emailError.value = true;
};

const open = () => {
  if (store.canPayWithCard && store.isCrossmintVerified) {
    checkoutState.value = 'payment-method';
    telemetry.paymentMethodsPreview();
  } else {
    checkoutState.value = 'buy-with-eth';
    telemetry.paymentPreview('eth');
  }

  // HACK: Need this since for some reason
  // our connect widget logic doesn't populate the widget when the modal opens
  setTimeout(() => {
    showConnectWidget.value = true;
  }, 0);

  isModalOpen.value = true;
};

const close = () => {
  showConnectWidget.value = false;
  showSubscribeWidget.value = false;
  isModalOpen.value = false;
};

const transformedMintingError = computed(() => {
  if (isMintingError.value || mintingError.value) {
    return transformError(mintingError.value)?.error;
  }
  return null;
});

const maxClaimable = computed(() => {
  if (store.claimableQuantity < Infinity && (store.hasAllowlist || store.hasWalletLimit)) {
    if (store.claimableQuantity === 0) {
      return -1;
    }

    return store.claimableQuantity as number;
  } else {
    return 0;
  }
});

const mintButtonLabel = computed(() => {
  if (store.cost.eq(0)) {
    return 'Claim Now';
  } else {
    return 'Buy Now';
  }
});

const tweetLabel = computed(() => {
  if (store.cost.eq(0)) {
    return 'claimed';
  } else {
    return 'purchased';
  }
});

const tweetText = computed(
  () => {
    if (store.creator.twitterUrl) {
      return `I just ${tweetLabel.value} ${store.name} from @${store.creator.twitterUrl} via @manifoldxyz%0A%0Ahttps://app.manifold.xyz/c/${store.slug}?utm_source=minted_tweet`;
    }

    return `I just ${tweetLabel.value} ${store.name} from ${store.creatorEnsOrFormattedWalletAddress} via @manifoldxyz%0A%0Ahttps://app.manifold.xyz/c/${store.slug}?utm_source=minted_tweet`;
  }
);

const wrongNetworkText = computed(() => {
  const networkName = ETHEREUM_NETWORK_NAMES[store.networkId!];
  const capitalized = capitalize(networkName.toLowerCase());
  return `Please switch to the ${capitalized} network to continue.`;
});

function checkApplePay () {
  if (window.ApplePaySession) {
    return true;
  }
  return false;
}

function getCalendarString (dayjsDate: dayjs.Dayjs | null) {
  return dayjsDate?.calendar(null, CalendarFormat) || '';
}

const claimStartDate = computed(() => {
  if (store.startDate) {
    return dayjs(store.startDate);
  }
  return null;
});

const claimEndDate = computed(() => {
  if (store.endDate) {
    return dayjs(store.endDate);
  }
  return null;
});

// Need this to make sure the modal height is correct on Safari
const vh95 = ref('0px');

const setMaxHeight = () => {
  vh95.value = window.innerHeight * 0.95 + 'px';
};

onMounted(() => {
  setMaxHeight();
  window.addEventListener('resize', setMaxHeight);
  window.addEventListener('m-subscribe-success', subscribedToCreator);
  email.value = tryGetLocalStorage(CROSSMINT_EMAIL_LOCAL_STORAGE_KEY);
});

onUnmounted(() => {
  window.removeEventListener('resize', setMaxHeight);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TransitionRoot), { show: isModalOpen.value }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          class: "checkout",
          onClose: close
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "checkout-backdrop-enter-animation",
              "enter-from": "checkout-backdrop-enter-from-animation",
              "enter-to": "checkout-backdrop-enter-to-animation",
              leave: "checkout-backdrop-leave-animation",
              "leave-from": "checkout-backdrop-leave-from-animation",
              "leave-to": "checkout-backdrop-leave-to-animation"
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "checkout-enter-animation",
              "enter-from": "checkout-enter-from-animation",
              "enter-to": "checkout-enter-to-animation",
              leave: "checkout-leave-animation",
              "leave-from": "checkout-leave-from-animation",
              "leave-to": "checkout-leave-to-animation"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(DialogPanel), {
                    class: _normalizeClass(['checkout-modal', checkoutState.value === 'buy-with-card' ? 'checkout-modal--card' : '']),
                    style: _normalizeStyle({ 'max-height': vh95.value })
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("header", _hoisted_4, [
                        _createVNode(_unref(DialogTitle), { class: "checkout-title" }, {
                          default: _withCtx(() => [
                            (checkoutState.value === 'success')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Order successful"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_6, "Checkout"))
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: close
                          }, [
                            _createVNode(_unref(XMarkIcon))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", {
                          class: _normalizeClass(['checkout-inner-container', checkoutState.value === 'buy-with-card' && !isProcessingCardPayment.value ? 'checkout-inner-container--card' : ''])
                        }, [
                          (!isProcessingCardPayment.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                (!(checkoutState.value === 'success'))
                                  ? (_openBlock(), _createBlock(NumberToMintInput, {
                                      key: 0,
                                      "number-to-mint": _unref(store).tokensToMint,
                                      "max-number-to-mint": _unref(maxClaimable),
                                      onNumberToMintChanged: numberToMintChanged
                                    }, null, 8, ["number-to-mint", "max-number-to-mint"]))
                                  : _createCommentVNode("", true),
                                ((checkoutState.value === 'success'))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                      _createElementVNode("a", {
                                        class: "checkout-tweet-button",
                                        href: `https://twitter.com/intent/tweet?text=${_unref(tweetText)}`,
                                        target: "_blank"
                                      }, _hoisted_13, 8, _hoisted_10)
                                    ]))
                                  : _createCommentVNode("", true),
                                ((checkoutState.value === 'success'))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                      _createElementVNode("h2", _hoisted_15, "Never miss a drop by " + _toDisplayString(_unref(store).creatorEnsOrFormattedWalletAddress), 1),
                                      (showSubscribeWidget.value)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            "data-widget": "m-widget-subscribe",
                                            "data-creator-address": _unref(store).creator?.address,
                                            "data-tweet-subtext": `%0A%0Ahttps://app.manifold.xyz/c/${_unref(store).slug}?utm_source=subscribed_tweet`
                                          }, null, 8, _hoisted_16))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                ((checkoutState.value === 'success') && _unref(store).clientThemedText?.postMint)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                      _createElementVNode("span", {
                                        class: "checkout-post-mint-title",
                                        innerHTML: _unref(store).clientThemedText?.postMint
                                      }, null, 8, _hoisted_18)
                                    ]))
                                  : _createCommentVNode("", true),
                                (checkoutState.value === 'success')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                      _createVNode(PlatformLinks, {
                                        large: "",
                                        label: "View on",
                                        is1155: _unref(store).is1155,
                                        "has-mints": _unref(store).total > 0,
                                        "creator-contract-address": _unref(store).creatorContractAddress,
                                        "token-id": _unref(store).tokenId === null ? undefined : _unref(store).tokenId
                                      }, null, 8, ["is1155", "has-mints", "creator-contract-address", "token-id"]),
                                      (_unref(tx)?.hash)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            class: "checkout-tx-hash",
                                            href: `${_unref(getEtherscanBase)(_unref(store).networkId)}/tx/${_unref(tx)?.hash}`,
                                            target: "_blank"
                                          }, [
                                            _hoisted_21,
                                            _createVNode(_unref(ArrowTopRightOnSquareIcon), { class: "link-icon" })
                                          ], 8, _hoisted_20))
                                        : _createCommentVNode("", true),
                                      (paymentMethod.value === 'card' && !recipientAddress.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                            _createElementVNode("p", null, "You'll now receive an email at " + _toDisplayString(email.value) + " with your " + _toDisplayString(_unref(pluralize)(_unref(store).tokensToMint, 'item')), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                (!(checkoutState.value === 'success' || checkoutState.value === 'buy-with-card'))
                                  ? (_openBlock(), _createBlock(CheckoutItems, {
                                      key: 5,
                                      "number-to-mint": _unref(store).tokensToMint,
                                      cost: _unref(store).cost,
                                      "has-fees": _unref(store).hasProcessingFees,
                                      price: _unref(store).price,
                                      "price-in-usd": _unref(store).priceInUsd,
                                      "manifold-fee": _unref(store).manifoldFee,
                                      "manifold-fee-in-usd": _unref(store).manifoldFeeInUsd,
                                      total: _unref(store).totalCost,
                                      "total-in-usd": _unref(store).totalCostInUsd,
                                      "erc-twenty": _unref(store).erc20Address ? _unref(store).erc20Symbol : ''
                                    }, null, 8, ["number-to-mint", "cost", "has-fees", "price", "price-in-usd", "manifold-fee", "manifold-fee-in-usd", "total", "total-in-usd", "erc-twenty"]))
                                  : (checkoutState.value === 'buy-with-card')
                                    ? (_openBlock(), _createBlock(CheckoutItemsForCard, {
                                        key: 6,
                                        "number-to-mint": _unref(store).tokensToMint,
                                        "item-price": itemPriceWithCard.value,
                                        "manifold-fee": manifoldFeeWithCard.value,
                                        "processing-fees": processingFeesWithCard.value,
                                        "total-cost": totalCostWithCard.value,
                                        "loading-prices": loadingPrices.value
                                      }, null, 8, ["number-to-mint", "item-price", "manifold-fee", "processing-fees", "total-cost", "loading-prices"]))
                                    : _createCommentVNode("", true),
                                _createVNode(OptimismBanner, { class: "checkout-network" }),
                                (checkoutState.value !== 'buy-with-card')
                                  ? (_openBlock(), _createBlock(_Transition, {
                                      key: 7,
                                      mode: "out-in"
                                    }, {
                                      default: _withCtx(() => [
                                        (checkoutState.value === 'payment-method')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                              _createElementVNode("button", {
                                                class: "checkout-payment-method-button",
                                                type: "button",
                                                onClick: _cache[0] || (_cache[0] = ($event: any) => (goToBuyWithEth()))
                                              }, _hoisted_26),
                                              _createElementVNode("button", {
                                                class: "checkout-payment-method-button",
                                                type: "button",
                                                onClick: _cache[1] || (_cache[1] = ($event: any) => (goToBuyWithCard()))
                                              }, [
                                                _hoisted_27,
                                                _createElementVNode("div", _hoisted_28, [
                                                  (checkApplePay())
                                                    ? (_openBlock(), _createElementBlock("img", _hoisted_29))
                                                    : _createCommentVNode("", true),
                                                  _hoisted_30,
                                                  _hoisted_31,
                                                  _hoisted_32
                                                ])
                                              ])
                                            ]))
                                          : (checkoutState.value === 'buy-with-eth')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                                (_unref(store).isConnected)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                                      _createElementVNode("div", _hoisted_35, [
                                                        _createElementVNode("div", null, [
                                                          _hoisted_36,
                                                          _createElementVNode("span", null, _toDisplayString(_unref(store).ensOrFormattedWalletAddress), 1)
                                                        ]),
                                                        (showConnectWidget.value)
                                                          ? (_openBlock(), _createElementBlock("div", {
                                                              key: 0,
                                                              id: "checkout-disconnect",
                                                              "data-widget": "m-connect",
                                                              "data-grant-type": "signature",
                                                              "data-client-id": "02865a407876e82f4389f70992c25323e967504d37663290f11fd49e79b607e0",
                                                              "data-app-name": "Manifold Notifications",
                                                              "data-delay-auth": "always",
                                                              "data-wallet-connect-project-id": "ca03bf2709bfa142a2d9adb0d6e99e7f",
                                                              "data-network": _unref(store).networkId,
                                                              "data-fallback-provider": _unref(store).fallbackProvider ? _unref(store).fallbackProvider : undefined,
                                                              "data-enable-network-switching": true,
                                                              "data-browser-provider-ignore-disconnect": true,
                                                              "data-multi": "true",
                                                              "data-message": "Please sign this message to confirm your wallet address",
                                                              "data-always-open": true
                                                            }, null, 8, _hoisted_37))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      (_unref(store).eligibleVaultWallets && _unref(store).walletAddress)
                                                        ? (_openBlock(), _createBlock(DelegationPicker, {
                                                            key: 0,
                                                            class: "checkout-delegation-picker",
                                                            selectedWallet: _unref(store).mintForWallet ?? _unref(store).walletAddress,
                                                            delegatedWallet: _unref(store).walletAddress,
                                                            vaultWallets: _unref(store).eligibleVaultWallets,
                                                            onWalletSelect: _cache[2] || (_cache[2] = ($event: any) => (_unref(store).setMintForWallet($event)))
                                                          }, null, 8, ["selectedWallet", "delegatedWallet", "vaultWallets"]))
                                                        : _createCommentVNode("", true),
                                                      (
                          !_unref(store).isChainCorrect
                          || !_unref(store).hasTokensToMint
                          || _unref(store).tokensToMint > _unref(store).claimableQuantity
                          || !_unref(store).hasEnoughEth
                          || _unref(isMintingError)
                        )
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                                            (!_unref(store).isChainCorrect)
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_unref(wrongNetworkText)), 1))
                                                              : (_unref(isMintingError))
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_unref(transformedMintingError)), 1))
                                                                : (!_unref(store).hasTokensToMint)
                                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_unref(store).tokensMintedByWallet === 0 || _unref(store).tokensMintedByWallet === null
                                      ? 'Sorry, there are no items for you to claim.'
                                      : 'You\'ve claimed all your items.'), 1))
                                                                  : (_unref(store).tokensToMint > _unref(store).claimableQuantity)
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_42, "You can't claim more than " + _toDisplayString(`${_unref(maxClaimable)} ${_unref(pluralize)(_unref(maxClaimable), 'item')}`), 1))
                                                                    : (!_unref(store).hasEnoughEth)
                                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_43, "You don't have enough funds. " + _toDisplayString((_unref(store).canPayWithCard && _unref(store).isCrossmintVerified) ? 'Pay with card instead.' : ''), 1))
                                                                      : _createCommentVNode("", true)
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      _createElementVNode("div", _hoisted_44, [
                                                        (_unref(tx)?.hash)
                                                          ? (_openBlock(), _createElementBlock("a", {
                                                              key: 0,
                                                              class: "checkout-tx-hash",
                                                              href: `${_unref(getEtherscanBase)(_unref(store).networkId)}/tx/${_unref(tx)?.hash}`,
                                                              target: "_blank"
                                                            }, [
                                                              _hoisted_46,
                                                              _createVNode(_unref(ArrowTopRightOnSquareIcon), { class: "link-icon" })
                                                            ], 8, _hoisted_45))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _createElementVNode("div", {
                                                        id: "restricted-token",
                                                        class: "manifold-scheme-dark",
                                                        "data-widget": "m-restricted-token",
                                                        "data-network": _unref(store).networkId,
                                                        "data-address": _unref(store).creatorContractAddress
                                                      }, null, 8, _hoisted_47),
                                                      (_unref(store).hasEnoughEth || _unref(store).hasTokensToMint)
                                                        ? (_openBlock(), _createElementBlock("button", {
                                                            key: 2,
                                                            class: "campaign-buy-button",
                                                            type: "button",
                                                            disabled: 
                          _unref(isMinting)
                          || !_unref(store).isChainCorrect
                          || _unref(store).isSoldOut
                          || _unref(store).status === 'ended'
                          || !_unref(store).hasTokensToMint
                          || _unref(store).tokensToMint > _unref(store).claimableQuantity
                          || _unref(store).tokensToMint < 1
                        ,
                                                            onClick: _cache[3] || (_cache[3] = ($event: any) => (!_unref(store).hasEnoughEth ? checkoutState.value = 'buy-with-card' : mintTokens()))
                                                          }, [
                                                            (!_unref(store).isChainCorrect)
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_49, "Wrong Network"))
                                                              : (_unref(store).isSoldOut)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_50, "Sold Out"))
                                                                : (_unref(store).status === 'ended')
                                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_51, "Sale Ended"))
                                                                  : (_unref(isMinting))
                                                                    ? (_openBlock(), _createElementBlock("i", _hoisted_52))
                                                                    : (!_unref(store).hasEnoughEth && _unref(store).canPayWithCard && _unref(store).isCrossmintVerified)
                                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_53, "Pay with Card"))
                                                                      : (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(_unref(mintButtonLabel)), 1))
                                                          ], 8, _hoisted_48))
                                                        : (_unref(store).canPayWithCard && _unref(store).isCrossmintVerified)
                                                          ? (_openBlock(), _createElementBlock("button", {
                                                              key: 3,
                                                              class: "checkout-payment-method-button",
                                                              type: "button",
                                                              onClick: _cache[4] || (_cache[4] = ($event: any) => (checkoutState.value = 'buy-with-card'))
                                                            }, [
                                                              _hoisted_55,
                                                              _createElementVNode("div", _hoisted_56, [
                                                                (checkApplePay())
                                                                  ? (_openBlock(), _createElementBlock("img", _hoisted_57))
                                                                  : _createCommentVNode("", true),
                                                                _hoisted_58,
                                                                _hoisted_59,
                                                                _hoisted_60
                                                              ])
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                                      (showConnectWidget.value)
                                                        ? (_openBlock(), _createElementBlock("div", {
                                                            key: 0,
                                                            id: "checkout-connect",
                                                            "data-widget": "m-connect",
                                                            "data-grant-type": "signature",
                                                            "data-client-id": "02865a407876e82f4389f70992c25323e967504d37663290f11fd49e79b607e0",
                                                            "data-app-name": "Manifold Notifications",
                                                            "data-delay-auth": "always",
                                                            "data-wallet-connect-project-id": "ca03bf2709bfa142a2d9adb0d6e99e7f",
                                                            "data-network": _unref(store).networkId,
                                                            "data-fallback-provider": _unref(store).fallbackProvider ? _unref(store).fallbackProvider : undefined,
                                                            "data-enable-network-switching": true,
                                                            "data-browser-provider-ignore-disconnect": true,
                                                            "data-multi": "true",
                                                            "data-message": "Please sign this message to confirm your wallet address",
                                                            "data-always-open": true
                                                          }, null, 8, _hoisted_62))
                                                        : _createCommentVNode("", true)
                                                    ]))
                                              ]))
                                            : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (!isProcessingCardPayment.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                _createVNode(_Transition, {
                                  name: "fade-in",
                                  appear: ""
                                }, {
                                  default: _withCtx(() => [
                                    (checkoutState.value === 'buy-with-card')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                          _createElementVNode("div", null, [
                                            _hoisted_65,
                                            _withDirectives(_createElementVNode("input", {
                                              onFocusout: validateEmail,
                                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((email).value = $event)),
                                              class: _normalizeClass(['checkout-text-input', emailError.value ? 'checkout-error' : '']),
                                              name: "email",
                                              type: "email",
                                              placeholder: "example@manifold.xyz"
                                            }, null, 34), [
                                              [_vModelText, email.value]
                                            ]),
                                            (emailError.value)
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_66, " A valid email is required "))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createVNode(RecipientAddressInput, {
                                            onOnAddressChanged: _cache[6] || (_cache[6] = ($event: any) => (recipientAddress.value = $event))
                                          }),
                                          (
                          doesCardPayerHaveAWallet.value &&
                          !loadingPrices.value &&
                          (
                            !_unref(store).hasTokensToMint
                            || _unref(store).tokensToMint > _unref(store).claimableQuantity
                          )
                        )
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                                (!_unref(store).hasTokensToMint)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(_unref(store).tokensMintedByWallet === 0 || _unref(store).tokensMintedByWallet === null
                                ? 'Sorry, there are no items for you to claim.'
                                : 'You\'ve claimed all your items.'), 1))
                                                  : (_unref(store).tokensToMint > _unref(store).claimableQuantity)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_69, "You can't claim more than " + _toDisplayString(`${_unref(maxClaimable)} ${_unref(pluralize)(_unref(maxClaimable), 'item')}`), 1))
                                                    : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", _hoisted_70, [
                                            _createVNode(CardPaymentForm, {
                                              network: _unref(store).networkId,
                                              email: email.value,
                                              type: _unref(store).claimType,
                                              "mint-count": _unref(store).tokensToMint,
                                              "total-price": _unref(formatEther)(_unref(store).totalCost),
                                              "creator-contract-address": _unref(store).creatorContractAddress,
                                              "claims-contract-address": _unref(store).overrideMintExtensionAddress ? _unref(store).overrideMintExtensionAddress : _unref(store).extensionAddress,
                                              "crossmint-client-id": _unref(store).crossmintClientId,
                                              "claim-index": _unref(store).claimIndex,
                                              "merkle-proofs": _unref(store).claimableMerkleProofs || [],
                                              "mint-indices": _unref(store).claimableMintIndices || [],
                                              "mint-for": recipientAddress.value || null,
                                              "on-payment-started": onCardPaymentStarted,
                                              "on-success": onCardPaymentSuccess,
                                              "on-error": onCardPaymentError,
                                              "on-cost-changed": onCardPaymentCostChanged,
                                              "on-recipient-wallet-changed": onCardPaymentRecipientWalletChanged
                                            }, null, 8, ["network", "email", "type", "mint-count", "total-price", "creator-contract-address", "claims-contract-address", "crossmint-client-id", "claim-index", "merkle-proofs", "mint-indices", "mint-for"])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ], 2),
                        (isProcessingCardPayment.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                              _hoisted_72,
                              _hoisted_73,
                              (_unref(tx)?.hash)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "checkout-tx-hash",
                                    href: `${_unref(getEtherscanBase)(_unref(store).networkId)}/tx/${_unref(tx)?.hash}`,
                                    target: "_blank"
                                  }, [
                                    _hoisted_75,
                                    _createVNode(_unref(ArrowTopRightOnSquareIcon), { class: "link-icon" })
                                  ], 8, _hoisted_74))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["class", "style"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createElementVNode("button", {
      onClick: open,
      class: "campaign-buy-button",
      disabled: 
        _unref(store).isLoadingWeb3State
        || _unref(store).isDelegationLoading
        || _unref(store).isSoldOut
        || _unref(store).status === 'not-started'
        || _unref(store).status === 'ended'
      
    }, [
      (_unref(store).isLoadingWeb3State || _unref(store).isDelegationLoading)
        ? (_openBlock(), _createElementBlock("i", _hoisted_77))
        : (_unref(store).status === 'not-started')
          ? (_openBlock(), _createElementBlock("div", _hoisted_78, " Drops " + _toDisplayString(getCalendarString(_unref(claimStartDate))), 1))
          : (_unref(store).status === 'ended')
            ? (_openBlock(), _createElementBlock("div", _hoisted_79, " Ended " + _toDisplayString(getCalendarString(_unref(claimEndDate))), 1))
            : (_unref(store).isSoldOut)
              ? (_openBlock(), _createElementBlock("div", _hoisted_80, " Sold out "))
              : (_openBlock(), _createElementBlock("span", _hoisted_81, _toDisplayString(_unref(mintButtonLabel)), 1))
    ], 8, _hoisted_76)
  ]))
}
}

})